import React from "react";
import ImagenPhone from "../../../../new_images/Landing/Mix/Mix_inicio_telf.png";
import IconMedalla from "../../../../new_images/Landing/Icons/Icon_inicio_medalla.png";
import IconNube from "../../../../new_images/Landing/Icons/Icon_inicio_nube.png";
import IconMoney from "../../../../new_images/Landing/Icons/Icon_inicio_money.png";
import IconTrofeo from "../../../../new_images/Landing/Icons/Icon_inicio_trofeo.png";
import "./WhyChooseTovo.css"

const WhyChooseTovo = () => {
  return (
    <section className="text-left my-5">
      <p
        className="titulo mb-3"
      >
        ¿Por qué elegir Tovo?
      </p>
      <p
        className="texto mb-5 "
      >
        Tovo ofrece un servicio único dentro del mundo del transporte compartido.
      </p>


      <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px"
                }}>
        <div className="view-WhyChooseTovo col-lg-11" >
          <div className="row">

            <div id="izquierda" className="col-lg-4" >
              <div className="img_izquierda">
              <img src={IconMedalla} height="65px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              <p className="p_izquierda title_1">Servicio de calidad</p>
              <p className="p_izquierda body_1">Contamos con conductores profesionales y verificados, además puedes conocer todos los detalles de tu viaje y compartirlos con tus contactos de confianza</p>
              
              <div className="img_izquierda">
              <img src={IconMoney} height="65px" alt="servicio de calidad" style={{marginTop: "20px", marginBottom: "20px"}} /> 
              </div>
              <p className="p_izquierda title_1">Precios accesibles y transparentes</p>
              <p className="p_izquierda body_1">Conoce el precio de tu viaje antes de iniciarlo para que puedas movilizarte sin problemas ni molestias durante un viaje.  Al compartir viajes los precios son los más bajos del mercado.</p>
            </div>


            <div id="phone" className="col-lg-4" style={{display: "flex", justifyContent:"center", marginTop:"10px", marginBottom:"10px"}}>
                <img className="ml-3" src={ImagenPhone} height="450px" alt="phone" /> 
            </div>
            
            
            <div id="derecha" className="col-lg-4" >
            <div className="img_derecha ml-2">
              <img src={IconNube} height="65px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              <p className="p_derecha title_1 ml-2">Reducción de la huella de carbono</p>
              <p className="p_derecha body_1 ml-2">Reconocemos tu preocupación por el medio ambiente, por eso Tovo está enfocado en conectar pasajeros y conductore s que al compartir rutas contribuyan a  la reducción de las emisiones de CO2.</p>
              
              <div className="img_derecha ml-2">
              <img src={IconTrofeo} height="65px" alt="servicio de calidad" style={{marginTop: "20px", marginBottom: "10px"}} /> 
              </div>
              <p className="p_derecha title_1 ml-2">Conéctate con diversos usuarios de tu localidad</p>
              <p className="p_derecha body_1 ml-2">El servicio de transporte compartido de Tovo te brinda la posibilidad de conocer a un sin fin de personas interesadas en los mismos destinos que tu frecuentas.</p>
            
            </div>


          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseTovo;
